// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2DTOG","containerItemsCenter":"Skeleton_containerItemsCenter__1T_6Q"};